export const theme = {
    color: {
        mineShaft: "rgba(34, 34, 34, 0.85)",
        wispPink: "rgba(204, 204, 204, 0.85)",
        alto: "rgb(208, 208, 208)",
        silver: "rgb(189, 189, 189)",
    },
    breakpoint: {
        mobileMax: 700,
    },
};